import React, { Component } from "react";

import "./css/impressao.css";
import API from "../../../actions/api-helper";
import UI from "../../../actions/ui-helper";

class ImpressaoReuniao extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    UI.loader("show", "Aguarde, gerando relatório...");
    API.get("/reunioes/" + this.props.match.params.id)
      .then(function (json) {
        console.log(json.data);
        this.setState(json.data);
        UI.loader("hide");
      }.bind(this)).catch(function (json) {
        UI.alert(false, json.message);
      });
  }

  render() {
    if (!this.state.id) return false;

    let styleCabecalho = {
      fontSize: "14px",
      margimBottom: "20px"
    };
    let styleAssinatura = {
      width: "20%",
      margin: "8px",
      display: "inline-block",
      borderTop: "1px solid black",
      verticalAlign: "top"
    };
    let styleAlign = {
      verticalAlign: "top"
    };
    let styleLabel = {
      width: "15%",
      fontWeight: "700",
      display: "inline-block"
    };
    let styleDesc = {
      width: "85%",
      display: "inline-block"
    };

    // Dados do cabeçalho
    let empresa = this.props.usuario.empresa;
    let endereco = this.props.usuario.empresa.endereco;

    return (
      <div className="report">
        <button className="btn btn-primary btn-float-right" onClick={() => window.print()}><i className="icon icon-printer"></i>Preparar para Impressão</button>
        <header className="report-header">
          <h2>{empresa.razaoSocial}</h2>
          <h3>CNPJ: {empresa.cnpj}</h3>
        </header>
        <hr></hr>
        <div style={styleCabecalho}>
          {(this.state.procedimento.ataReuniao ?
            <div style={styleAlign}>
              <span style={styleLabel}>ATA {'0' + this.state.id} - DATA: {this.state.data}</span><br />
            </div> :
            <div style={styleAlign}>
              <span style={styleLabel}>{/*" REUNIÃO / ATIVIDADE - 0 + this.state.id*/}DATA: {this.state.data}</span><br />
            </div>)}
          < br />
          <span style={styleLabel}>HORÁRIO:</span>{this.state.horaEntrada.substr(0, 5)} às {this.state.horaSaida.substr(0, 5)}h<br />
          <span style={styleLabel}>PARTICIPANTES:</span>
          {this.state.valores.map(
            (valor, i) => {
              let last = this.state.valores.length - 1;
              let separador = (i + 1) === last ? ' e ' : (i + 1) < last ? ', ' : '';
              return (<span key={i}>{valor.usuarioNome}{separador}</span>);
            })}
          <br />
          <span style={styleLabel}>CÓDIGO:</span>{this.state.procedimento.codigo}<br />
          <div style={styleAlign}>
            <span style={styleLabel}>ATIVIDADE:</span>
            <span style={styleDesc}>{this.state.procedimento.descricao}</span>
          </div><br />
          <span style={styleLabel}>PAUTA:</span>{this.state.pauta}
        </div>
        <ol>
          {this.state.topicos.map(function (topico, i) {
            let linhas = topico.descricao.split("\n");
            return (
              <li key={i}>{linhas.map(function (value, j) {
                return <React.Fragment key={j}>
                  {value}{(j + 1) < linhas.length ? <br></br> : null}
                </React.Fragment>
              })}</li>);
          })}
        </ol>
        <footer className="report-footer">
          <div>{this.state.valores.map(function (valor, i) {
            return (<div style={styleAssinatura} key={i}>{valor.usuarioNome}</div>)
          })}</div>
          <hr></hr>
          {endereco.logradouro} {endereco.numero} - {endereco.bairro} - cep {endereco.cep}<br />
          {empresa.telefoneComercial} - {empresa.telefoneCelular}<br />
          {empresa.email}<br />
          {endereco.cidade} - {endereco.estado}
        </footer>
      </div >
    );
  }
}

export default ImpressaoReuniao;